import { Navbar, Footer } from "@/components/Navbar";
import { ShieldCheck } from "lucide-react";

const updated = "Junho de 2026";

export default function Privacidade() {
  return (
    <div className="min-h-screen bg-[#fafaf8]">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-[#1b5e3f] bg-[#e8f0ec] px-3 py-1.5 rounded-full"><ShieldCheck className="w-3.5 h-3.5" /> Privacidade</span>
        <h1 className="font-head text-4xl font-bold text-[#1c1917] mt-5">Política de Privacidade</h1>
        <p className="text-[#78716c] mt-2">Última atualização: {updated}</p>

        <div className="prose prose-stone mt-8 space-y-6 text-[#44403c] leading-relaxed">
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">1. Quem somos</h2>
            <p>O Portal Brasil Portugal ("Plataforma", "nós") é a ponte digital entre o Brasil e Portugal, conectando pessoas, empresas, oportunidades, serviços e informação. Esta política explica como tratamos os seus dados pessoais, em conformidade com o RGPD (UE) e a LGPD (Brasil).</p>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">2. Dados que coletamos</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Dados de cadastro: nome, e-mail e senha (ou login via Google).</li>
              <li>Dados de perfil profissional: setor, cidade, região, contatos e descrição.</li>
              <li>Dados de imóveis e documentos de verificação: número de CPF, autorização de residência ou cadastro na ordem dos mediadores, contrato/declaração do imóvel e selfie de verificação.</li>
              <li>Dados de pagamento processados de forma segura pelo Stripe (não armazenamos dados de cartão).</li>
              <li>Mensagens enviadas no "Fale Conosco" e dados de uso da Plataforma.</li>
            </ul>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">3. Como usamos os dados</h2>
            <p>Utilizamos os dados para criar e manter o seu cadastro, exibir o seu perfil/anúncios no diretório, processar assinaturas e pagamentos, verificar a identidade de anunciantes de imóveis, prestar suporte e cumprir obrigações legais.</p>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">4. Documentos de verificação</h2>
            <p>Os documentos enviados (CPF, autorização de residência, contrato e selfie) são <strong>privados</strong> e acessíveis apenas a você e à equipe administrativa, exclusivamente para fins de verificação. Não são exibidos publicamente.</p>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">5. Compartilhamento</h2>
            <p>Compartilhamos dados apenas com prestadores essenciais (ex.: Stripe para pagamentos, serviços de hospedagem e armazenamento) e quando exigido por lei. Não vendemos os seus dados.</p>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">6. Seus direitos</h2>
            <p>Você pode acessar, corrigir ou excluir os seus dados e o seu perfil/anúncios a qualquer momento pelo painel, ou solicitar a exclusão da conta. Para exercer seus direitos, fale conosco pela página de contato.</p>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">7. Retenção e segurança</h2>
            <p>Mantemos os dados pelo tempo necessário às finalidades descritas e adotamos medidas técnicas e organizacionais para protegê-los.</p>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">8. Contato</h2>
            <p>Dúvidas sobre privacidade? Utilize a página <a href="/contato" className="text-[#1b5e3f] font-semibold underline">Fale Conosco</a>.</p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
